import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/account-management-certificates'
import { AppContext } from '/providers/app-context'

import Menu from '/components/account/nav-menu'
import AccountCertificates from '/components/account/certificates'

const AccountManagementCertificates = () => {

  const navigate = useNavigate()

  const { client,user } = useContext(AppContext)

  if (!user?.permissions.client_admin) navigate("../password")

  return (
    <PageWrapper title="Certificate Management" HelpText={HelpText} heading="Certificate Management" menu={<Menu client={client} user={user}/>}>
      <div className='flex h-full min-h-0 flex-col'>
        <AccountCertificates />
      </div>
    </PageWrapper>
  )
}

export default AccountManagementCertificates
